
export default {
  mapForm: {
    placesAndDirections: 'Suche & Los',
    isochrones: 'Erreichbarkeit',
    uploadedContentRendered: 'Hochgeladene Inhalte gerendert',
    errorRenderingContentUploaded: 'Fehler beim Hochladen der Inhalte. Bitte überprüfen Sie das Dateiformat und den Inhalt.'
  }
}
